import type { FavoritesConfig } from '#types/config/components/favorites'
import type { RecursivePartial } from '#types/utils'

export default {
  list: {
    brandClasses: {
      title: 'subtitle-2'
    }
  },
  dialogOptions: {
    type: 'panel'
  }
} satisfies RecursivePartial<FavoritesConfig>
